// Zoom del tablero kanban de leads. Escala SOLO las columnas de stages (ancho,
// paddings y tipografia de las cards) via la variable CSS `--kanban-scale`, para
// no tener que usar el zoom del navegador, que encoge tambien menu y filtros.
//
// Se usa `zoom`/`transform: scale` a proposito NO: react-beautiful-dnd calcula
// el arrastre en px de cliente y con un contenedor escalado la card se separa
// del cursor. Escalar medidas reales mantiene el drag & drop exacto.

const KANBAN_ZOOM_STORAGE_KEY = 'leads-kanban-zoom'

export const KANBAN_ZOOM_MIN = 0.6
export const KANBAN_ZOOM_MAX = 1
export const KANBAN_ZOOM_STEP = 0.1

/** Ancho base de una columna de stage al 100% */
export const KANBAN_COLUMN_WIDTH = 250

export const clampKanbanZoom = (value: number) =>
  Math.round(Math.min(KANBAN_ZOOM_MAX, Math.max(KANBAN_ZOOM_MIN, value)) * 100) / 100

export const getStoredKanbanZoom = (): number => {
  try {
    const stored = Number(window.localStorage.getItem(KANBAN_ZOOM_STORAGE_KEY))
    if (!stored || Number.isNaN(stored)) return KANBAN_ZOOM_MAX
    return clampKanbanZoom(stored)
  } catch {
    return KANBAN_ZOOM_MAX
  }
}

export const setStoredKanbanZoom = (zoom: number) => {
  try {
    window.localStorage.setItem(KANBAN_ZOOM_STORAGE_KEY, String(zoom))
  } catch {
    // Fail silently in incognito mode
  }
}

/** px escalados por el zoom del kanban, usable en estilos inline */
export const kz = (px: number) => `calc(${px}px * var(--kanban-scale, 1))`
